import React from "react";

const Lastservicetable = ({ data = [], loading }) => {
    if (loading) return <p className="p-4 text-blue-500">Loading...</p>;
    if (!data || data.length === 0)
        return <p className="p-4 text-gray-500">No data available</p>;

    return (
        <div className="p-4 overflow-x-auto">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-center">S.No</th>
                        <th className="px-4 py-2 text-left">Asset Number</th>
                        <th className="px-4 py-2 text-center">Last Service Date</th>
                        <th className="px-4 py-2 text-center">Service Value</th>
                        <th className="px-4 py-2 text-center">Assess Service</th>
                        <th className="px-4 py-2 text-center">Assess Sales</th>
                    </tr>
                </thead>
                <tbody>
                    {data.slice(0, 1).map((item, i) => (  // 👈 only first row
                        <tr
                            key={i}
                            className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}
                        >
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {i + 1}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-left">
                                {item.ASSET_NUMBER}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.LAST_SERVICE_DATE}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.Service_value ?? 0}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.assess_service ?? 0}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200 text-center">
                                {item.assess_sales ?? 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Lastservicetable;
